import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'getItemLocalStorage',
})
export class GetItemLocalStoragePipe implements PipeTransform {
	transform(value: any, args?: any): any {
		return localStorage.getItem(value);
	}
}
